import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'hfc-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent {
  public message: string;

  constructor(
    private router: Router,
    private navigationService: NavigationService
  ) {
    const extras = this.router.getCurrentNavigation().extras;

    if (extras && extras.state) {
      this.message = extras.state['error-message'];
    }
  }

  public onReturnClicked() {
    this.navigationService.goToDashboard();
  }
}
